import React, { useEffect, useState } from "react";
import {
  RecommendationTranslationDto,
  RecommendationDto,
} from "@green0meter/api-client";

import Actions from "./components/Actions";
import Description from "./components/Description";
import Emissions from "./components/Emissions";
import Subsidy from "./components/Subsidy";
import Products from "./components/Products";
import Steps from "./components/Steps";

import { Grid } from "@components/base";
import { getRecommendationLanguage } from "@components/main/recommendation/Recommendations.helpers";

interface RecommendationDetails {
  recommendation: RecommendationDto;
}

const RecommendationDetails: React.FC<RecommendationDetails> = ({
  recommendation,
}) => {
  const { translations } = recommendation;
  const [content, setContent] = useState<RecommendationTranslationDto>();
  const currentLanguage = getRecommendationLanguage();

  useEffect(() => {
    setContent(
      translations.find(
        ({ languages_code }: RecommendationTranslationDto): boolean =>
          languages_code === currentLanguage,
      ),
    );
  }, [currentLanguage, recommendation]);

  if (!content) return null;

  const {
    propducts,
    subventions_insurance,
    title,
    full_description,
    emission_number,
    emission_text,
    block_title,
    block_text,
    steps,
  } = content;

  const subsidy =
    subventions_insurance &&
    subventions_insurance.find(({ Type }) => Type === "subsidy")!;

  return (
    <Grid container spacing={3}>
      <Grid size={12}>
        <Actions recommendation={recommendation} />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <Description title={title} description={full_description} />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <Emissions
          {...{ emission_number, emission_text, block_text, block_title }}
        />
      </Grid>
      {subsidy && (
        <Grid size={12}>
          <Subsidy subsidy={subsidy} />
        </Grid>
      )}
      {propducts && propducts.length > 0 && (
        <Grid size={12}>
          <Products products={propducts} />
        </Grid>
      )}
      {steps && steps.length > 0 && (
        <Grid size={12}>
          <Steps steps={steps} />
        </Grid>
      )}
    </Grid>
  );
};

export default RecommendationDetails;
